import { ROUTE_CLUBS, ROUTE_EVENTS, ROUTE_PLAYER_PROFILE } from '@/constants/Routes'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const RedirectPage = () => {
  const navigate = useNavigate()
  const params = useParams()

  const { playerId, clubId, eventId, bracketId } = params

  useEffect(() => {
    if (playerId) return navigate(`${ROUTE_PLAYER_PROFILE}/${playerId}`)
    if (!eventId && !bracketId) return navigate(`${ROUTE_CLUBS}/${clubId}`)
    if (!bracketId) return navigate(`${ROUTE_EVENTS}/${eventId}`)
    return navigate(`${ROUTE_EVENTS}/${eventId}/bracket/${bracketId}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}
